import { ORPHEUS_ROUTE } from './routes'

/**
 * Legacy DefaultLayout order and visibility: Summary, Orphex MCP, then Orpheus, for sysadmin OR
 * flag. No badge: v3 dropped Orpheus's "Beta" badge, and the rail now renders `badgeKey`.
 */
export const orpheusNavItems = [
  {
    labelKey: 'orpheus.nav.label',
    icon: 'orpheus',
    navKey: 'orpheus',
    to: ORPHEUS_ROUTE,
    visibility: {
      control: 'multiple' as const,
      id: [{ control: 'flag', id: 'orpheus' }, { control: 'sysAdmin' }],
    },
  },
]
